var numericRegExp = /^-?\d*\.?\d*$/i;
export default (function (value, min, max) {
  if (!numericRegExp.test(value)) return 'The numeric value is invalid';
  if (!Number.isNaN(max) && parseFloat(value) > max) return "The numerical value must be less than or equal to ".concat(max);
  if (!Number.isNaN(min) && parseFloat(value) < min) return "The numerical value must be greater than or equal to ".concat(min);
  return '';
});